/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CustomerCardQuery = {
    /**
     * Card valid to. Type: 'DATE'
     */
    validTo?: string;
    /**
     * Customer identifier. Type: 'UUID'
     */
    customerId?: string;
    customerName?: string;
    username?: string;
    /**
     * Generated card application string identifier. Is unique.
     */
    applicationNumber?: string;
    cardNumber?: string;
    /**
     * Card state name.
     */
    state?: CustomerCardQuery.state;
    /**
     * If result should include virtual cards.
     */
    includeVirtualCard?: boolean;
    /**
     * If result should include QR Codes.
     */
    includeQrCode?: boolean;
    /**
     * Filter by customer card type.
     */
    cardType?: CustomerCardQuery.cardType;
    /**
     * Bank card token
     */
    token?: string;
    /**
     * Customer card group name
     */
    customerCardGroup?: string;
    /**
     * Filter only cards without customer card group. Default: false
     */
    withoutCustomerCardGroup?: boolean;
    /**
     * Filter by card type.
     */
    type?: CustomerCardQuery.type;
    /**
     * Card state name to exclude.
     */
    excludeState?: CustomerCardQuery.excludeState;
    /**
     * Filter data by tenant FTP username
     */
    tenantFTPName?: string;
    /**
     * Client current timezone offset in minutes. Is required.
     */
    timezoneOffset?: number;
    /**
     * Sort by. Default: id
     */
    sortBy?: string;
    /**
     * Sort order descendent. Default: true
     */
    sortDesc?: boolean;
    /**
     * Sort with locale. Default: sk
     */
    sortLocale?: string;
    /**
     * Page Size. Default: 25
     */
    limit?: number;
    /**
     * Offsetting x items. Default: 0
     */
    offset?: number;
};
export namespace CustomerCardQuery {
    /**
     * Card state name.
     */
    export enum state {
        NOT_ISSUED = 'NOT_ISSUED',
        ACTIVE = 'ACTIVE',
        BLOCKED = 'BLOCKED',
        EXPIRED = 'EXPIRED',
        IN_PROGRESS = 'IN_PROGRESS',
        TOKENIZED = 'TOKENIZED',
    }
    /**
     * Filter by customer card type.
     */
    export enum cardType {
        SMART_CARD = 'SMART_CARD',
        SMART_CARD_2 = 'SMART_CARD_2',
        SMART_CARD_WITHOUT_STRUCTURE = 'SMART_CARD_WITHOUT_STRUCTURE',
        BANK_CARD = 'BANK_CARD',
        MOBILE_PHONE = 'MOBILE_PHONE',
        WHITE_LIST_CARD = 'WHITE_LIST_CARD',
        EXTERNAL_CARD = 'EXTERNAL_CARD',
        QR_CODE_CARD = 'QR_CODE_CARD',
        PAPER_CARD = 'PAPER_CARD',
    }
    /**
     * Filter by card type.
     */
    export enum type {
        SMART_CARD = 'SMART_CARD',
        SMART_CARD_2 = 'SMART_CARD_2',
        SMART_CARD_WITHOUT_STRUCTURE = 'SMART_CARD_WITHOUT_STRUCTURE',
        BANK_CARD = 'BANK_CARD',
        MOBILE_PHONE = 'MOBILE_PHONE',
        WHITE_LIST_CARD = 'WHITE_LIST_CARD',
        EXTERNAL_CARD = 'EXTERNAL_CARD',
        QR_CODE_CARD = 'QR_CODE_CARD',
        PAPER_CARD = 'PAPER_CARD',
    }
    /**
     * Card state name to exclude.
     */
    export enum excludeState {
        NOT_ISSUED = 'NOT_ISSUED',
        ACTIVE = 'ACTIVE',
        BLOCKED = 'BLOCKED',
        EXPIRED = 'EXPIRED',
        IN_PROGRESS = 'IN_PROGRESS',
        TOKENIZED = 'TOKENIZED',
    }
}

